/**
 * @generated SignedSource<<bcddcd7f903696953ee0d3efdd046cea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type optionGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly option: {
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "optionGroupHeader_issueTableGrouping";
};
export type optionGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: optionGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"optionGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "optionGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "type": "JiraJqlOptionFieldValue"
};

(node as any).hash = "45f8a556fccbdfe752d726e04df3a2ee";

export default node;
